export default function NumPy_Tutorial() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">NumPy_Tutorial</h1>
      <p>Content for NumPy_Tutorial goes here.</p>
    </div>
  );
}